import { useState, useEffect } from 'react';
import { AxiosError, apiClient } from '../services/authService';
import { logger } from '@/utils/logger';

interface UnreadCountResponse {
  success: boolean;
  data?: {
    unread_messages?: number;
  };
}

interface UseUnreadChatsCountReturn {
  unreadCount: number;
  loading: boolean;
}

export function useUnreadChatsCount(): UseUnreadChatsCountReturn {
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let mounted = true;
    let pollInterval: NodeJS.Timeout | null = null;

    const fetchUnreadCount = async (): Promise<void> => {
      try {
        // 🔒 SECURITY: Token is in httpOnly cookie, sent automatically
        // No need to read from localStorage or set Authorization header
        const response = await apiClient.get<UnreadCountResponse>('/api/langchain/monitor/unread-count');

        if (mounted && response.data?.success && response.data?.data) {
          setUnreadCount(response.data.data.unread_messages || 0);
        }
      } catch (error) {
        logger.error('[useUnreadChatsCount] Error fetching count:', error as AxiosError);
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchUnreadCount();
    
    pollInterval = setInterval(fetchUnreadCount, 30000);

    return () => {
      mounted = false;
      if (pollInterval) {
        clearInterval(pollInterval);
      }
    };
  }, []);

  return { unreadCount, loading };
}
